export default "__VITE_ASSET__8HSUfh7cJHNFxCkInNzNXw__";